export default __webpack_public_path__ + "static/media/streaks 10.542ec45f.svg";